import { useState, useEffect } from 'react'
import firebase from '../firebase/compat'

/**
 * Haalt de datakwaliteitsscores van álle organisaties op via de
 * `getAllDataQualityScores` Cloud Function (europe-west1). Server-side gegate
 * op de Deccos-beheertenant — voor andere tenants faalt de call en blijft de
 * map leeg. Alleen aanroepen waar de beheertenant-context al vaststaat.
 *
 * AI-CONTEXT: See docs/features/datakwaliteitsscore.md
 *
 * @param {boolean} [enabled] - Sla de fetch over wanneer false (bv. geen beheertenant)
 * @returns {{ scoresByCompagny: Map<string, {CompagnyID: string, Score: number, Provisional: boolean, Profile: string}>, loading: boolean, error: Error | null }}
 */
const useAllDataQualityScores = (enabled = true) => {
    const [scoresByCompagny, setScoresByCompagny] = useState(
        /** @type {Map<string, object>} */ (new Map())
    )
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(/** @type {Error | null} */ (null))

    useEffect(() => {
        if (!enabled) return

        let active = true
        setLoading(true)
        setError(null)

        const getAllDataQualityScores = firebase
            .app()
            .functions('europe-west1')
            .httpsCallable('getAllDataQualityScores')

        getAllDataQualityScores({})
            .then((result) => {
                if (!active) return
                const scores = Array.isArray(result.data?.scores) ? result.data.scores : []
                setScoresByCompagny(new Map(scores.map((s) => [s.CompagnyID, s])))
            })
            .catch((err) => {
                console.error('useAllDataQualityScores error:', err)
                if (active) setError(err)
            })
            .finally(() => { if (active) setLoading(false) })

        return () => { active = false }
    }, [enabled])

    return { scoresByCompagny, loading, error }
}

export default useAllDataQualityScores
